<script>
/**
 * @file 私教预约
 */

import {privateOrderClasses, privateHistoryOrder} from '../__mock__/classes';
import ForkissIcon from './forkiss-icon';


export default {
    components: {
        ForkissIcon
    },
    filters: {
        classesType(value) {
            const obj = {
                postpartum: '产后',
                pregnancy: '孕期'
            };
            return obj[value];
        }
    },
    methods: {
        goto() {
            this.$router.push({name: 'public-order'});
        },
        viewAuthorDetail(item) {
            this.$router.push({
                name: 'author-detail',
                params: {
                    id: item.author_id,
                    refer_name: 'private-order'
                }
            });
        },
        handleTouchPlay() {
            let self = this;
            let moveX;
            let startX;
            let movebox = this.$refs.privateContainer;

            // 触摸开始
            function boxTouchStart(e) {
                let touch = e.touches[0];
                startX = touch.pageX;
            }

            function boxTouchMove(e) {
                let touch = e.touches[0];
                moveX = touch.pageX - startX;
            }

            function boxTouchEnd(e) {
                if (moveX > 0) { // 向右
                    self.$router.push({
                        name: 'public-order'
                    });
                }

                if (moveX < 0) { // 向左

                }
            }

            // 滑动对象事件绑定
            movebox.addEventListener('touchstart', boxTouchStart, false);
            movebox.addEventListener('touchmove', boxTouchMove, false);
            movebox.addEventListener('touchend', boxTouchEnd, false);
        }

    },
    mounted() {
        // this.$nextTick(function () {
        //     this.handleTouchPlay();
        // });
    },
    data() {
        return {
            privateOrderClasses: privateOrderClasses,
            privateHistoryOrder: privateHistoryOrder
        };
    }
};
</script>

<template lang="pug">
.forkiss-private-order-container(ref="privateContainer")
    .tabs-box
        .tab-item(@click="goto")
            span 课程预约
        .tab-item.active
            span 私教预约
    .private-order-wrapper
        p.waiting-info 暂未开放，敬请期待
        //- .order-classes-box(v-for="orderClass in privateOrderClasses",
        //-     data-touch="true",
        //-     @click="viewAuthorDetail(orderClass)")
        //-     .classes-img
        //-         .img
        //-     .classes-detail-box
        //-         div
        //-             .class-type {{orderClass.type | classesType}}
        //-             .name {{orderClass.author_name}}
        //-             ForkissIcon.time(icon="forkiss-icon-time") {{orderClass.start_time}}
        //-             ForkissIcon.address(icon="forkiss-icon-address") {{orderClass.address}}
        //- .history-box-title 上课历史
        //- .order-classes-box(v-for="orderClass in privateHistoryOrder")
            .classes-img
                .img.history-img
            .classes-detail-box
                div
                    .class-type {{orderClass.type | classesType}}
                    .name {{orderClass.author_name}}
                    ForkissIcon.time(icon="forkiss-icon-time") {{orderClass.start_time}}
                    ForkissIcon.address(icon="forkiss-icon-address") {{orderClass.address}}
</template>

<style lang="less" scoped>
.forkiss-private-order-container {
    position: relative;
    padding-bottom: 1rem;
    font-size: .24rem;
    background: #f7f7f7;
    height: 100%;
    overflow-y: auto;

    .tabs-box {
        display: flex;
        height: .88rem;
        line-height: .88rem;
        padding: 0 1rem;
        box-shadow: 0 .05rem .08rem 0 rgba(227, 227, 227, .27);
        font-size: .28rem;
        background: #FFF;

        .tab-item {
            position: relative;
            flex: 1;
            color: #828d93;
            text-align: center;

            span {
                position: relative;
            }

            &.active {
                color: #a4805b;

                span::after {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 0;
                    right: 0;
                    height: .02rem;
                    background: #a5805a;
                }
            }
        }
    }

    .private-order-wrapper {
        padding: .3rem;
    }

    .waiting-info {
        color: #999;
    }

    .order-classes-box {
        position: relative;
        display: flex;
        height: 2.3rem;
        margin-bottom: .3rem;
        box-shadow: 0 0.05rem 0.08rem 0 rgba(227, 227, 227, 0.27);
        background: #FFF;

        * {
            pointer-events: none;
        }

        .classes-img {
            position: relative;
            height: 100%;
            padding: 0 .28rem;
            display: flex;
            justify-content: center;
            align-items: center;

            .img {
                width: 2rem;
                height: 2rem;
                border-radius: 50%;
                background-image: url(../assets/classes-avatar.png);
                background-size: contain;
                background-repeat: no-repeat;
                border: .06rem solid #F6ece0;

                &.history-img {
                    opacity: .4;
                }
            }
        }

        &:nth-child(2n+1) {
            .classes-img .img {
                background-image: url(../assets/classes-avatar1.png);
            }
        }
        .classes-detail-box {
            position: relative;
            padding-left: .2rem;
            flex: 1;
            display: flex;
            align-items: center;


            .status-waiting {
                position: absolute;
                top: 0;
                right: .36rem;
                width: 1.26rem;
                height: .48rem;
                text-align: center;
                line-height: .48rem;
                background: #ffc68b;
                color: #FFF;
                font-size: .2rem;
            }
            .status-success {
                position: absolute;
                top: 0;
                right: .36rem;
                width: 1.26rem;
                height: .48rem;
                text-align: center;
                line-height: .48rem;
                background: #b0de95;
                color: #FFF;
                font-size: .2rem;
            }
            .class-type {
                color: #999;
                font-size: .2rem;
            }
            .name {
                font-size: .28rem;
                color: #a4805b;
            }
            .time {
                color: #999;
            }
            .address {
                color: #999;
            }
        }
    }

    .history-box-title {
        text-align: center;
        color: #999;
        margin-top: .6rem;
        margin-bottom: .3rem;
        font-size: .24rem;

        &::before {
            content: "";
            display: inline-block;
            width: .66rem;
            height: 1px;
            background: #CCC;
            margin-right: .15rem;
            vertical-align: super;
        }

        &::after {
            content: "";
            display: inline-block;
            width: .66rem;
            height: 1px;
            background: #CCC;
            margin-left: .15rem;
            vertical-align: super;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/private-order.vue